import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "bottom_right", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 6", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { d: "M3.5 3.5v-2a1 1 0 112 0v3a1 1 0 01-1 1h-3a1 1 0 110-2h2z", fill: "#FFF", stroke: "red" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
